import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import Contact from '@repo/utils/models/Contact';
import styles from './Properties.module.scss';

function LastUpdatedIndicator() {
  return <span className={styles.lastUpdatedIndicator} />;
}

function Property({
  indicator,
  label,
  value,
  loading,
}: {
  indicator?: React.ReactNode;
  label: string;
  value: string;
  loading: boolean;
}) {
  return (
    <div className={styles.property}>
      {indicator && <div className={styles.propertyIndicator}>{indicator}</div>}
      <div className={styles.propertyLabel}>{label}</div>
      <div className={styles.propertyValue}>{loading ? <>&mdash;</> : value}</div>
    </div>
  );
}

export default function Properties({ contact }: { contact: Contact }) {
  return (
    <Section>
      <SectionTitle underline>Properties</SectionTitle>
      <div className="text-small">
        {contact.informationLastUpdated && (
          <Property
            indicator={<LastUpdatedIndicator />}
            label="Last Updated"
            loading={!contact.isLoaded}
            value={contact.informationLastUpdated.relative()}
          />
        )}
        {contact.created && (
          <Property
            label="Created"
            loading={!contact.isLoaded}
            value={contact.created.relative()}
          />
        )}
      </div>
    </Section>
  );
}
